var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"tree_type-item py-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[(_vm.$route.params.id !== 'new')?_c('h1',[_vm._v("Tree Type #"+_vm._s(_vm.$route.params.id))]):_c('h1',[_vm._v("New Tree Type")]),(_vm.item)?_c('TreeTypeFormComponent',{attrs:{"item":_vm.item}}):_c('b-spinner')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }